export const MAPBOX_API_CONFIG = {
    geocodeForward: {
        url: 'https://api.mapbox.com/search/geocode/v6/forward',
        params: { types: 'place,street,address' },
    },
} as const;
